var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.productAuditId || _vm.skuId)?_c('sku-detail',{attrs:{"sku-id":_vm.skuId,"product-audit-id":_vm.productAuditId,"if-edit":_vm.ifEdit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }